export const notifications_hub = {
    Endpoint: "https://sockets.moons.ninja/"
}